import { gql } from '@apollo/client';

export const GET_CANDIDATE_QUERY = gql`
	query GetCandidate($id: ID!, $companyId: ID!) {
		getCandidate(id: $id, companyId: $companyId) {
			id
			firstName
			lastName
			contactInfo {
				id
				type
				value
			}
			referrals {
				id
				bonusEligible
				candidateId
				createdAt
				eligibilityNote
				referralSubmissions {
					id
					job {
						title
						id
					}
					referralDate
					referralId
					referralStatus
					referralType
				}
				applications {
					id
					legacyReferralId
					atsApplicationId
					atsApplicationDate
					lastModifiedBy
					applicationStatus
					applicationStage
					job {
						id
						externalJobId
						title
					}
				}
				user {
					id
					firstName
					lastName
					emailAddress
				}
				ownerships {
					id
					startDate
					endDate
					isActive
					reason
				}
			}
		}
	}
`;

export const GET_CANDIDATE_SEARCH_TOTALS_QUERY = gql`
	query GetCandidateSearchTotals($companyId: ID!) {
		getCandidateSearchTotals(companyId: $companyId) {
			totalApplications
			totalCandidates
			totalReferrals
		}
	}
`;

export const LIST_CANDIDATES_QUERY = gql`
	query ListCandidates(
		$companyId: String!
		$pageNumber: Int!
		$pageSize: Int!
		$query: String
	) {
		listCandidates(
			companyId: $companyId
			pageNumber: $pageNumber
			pageSize: $pageSize
			query: $query
		) {
			totalCount
			items {
				id
				firstName
				lastName
				ownershipEndDate
				referralCount
				applicationCount
				emailAddresses
				atsIds
				owner {
					id
					firstName
					lastName
				}
			}
		}
	}
`;
